import { AxiosError } from 'axios'
import { useFeedback } from 'context'
import { ApiResponseTypes, ReportsServices } from 'services'
import { useInfiniteQuery } from 'react-query'
import { getNextPageParam } from 'utils/getNextParam'

import { useParamsSelector } from 'hooks'

import { UseQueryOptionsTypes } from '../../queries.types'

export const useInfiniteStudentsQuery = (
  options: UseQueryOptionsTypes | undefined = {}
) => {
  const { useParams, enabled } = options

  const params = useParamsSelector()

  const queryParams = useParams ? params.objParams : {}

  const { alert } = useFeedback()

  const { data, ...infiniteQuery } = useInfiniteQuery(
    ['v2/reports/students', queryParams],
    (paginatedParams) =>
      ReportsServices.students.paginated({
        params: {
          page: paginatedParams.pageParam || 1,
          pageSize: 20,
          search: queryParams.searchStudent || queryParams.search,
          userGroupId: queryParams.userGroupId,
          orderBy: queryParams.orderBy,
          orderType: queryParams.orderType
        }
      }),
    {
      keepPreviousData: true,
      getNextPageParam,
      onError: (error: AxiosError<ApiResponseTypes<unknown>>) => {
        alert.showError(error.response?.data.message || error.message)
      },
      enabled,
      cacheTime: 0
    }
  )

  return {
    data: data?.pages.flatMap((page) => page.data) || [],
    dataCount:
      data?.pages.flatMap((page) => page.pagination?.dataCount)[0] || 0,
    ...infiniteQuery
  }
}
